import { usePathname } from "next/navigation";

export const useLanguageFromPath = (): 'en' | 'ru' => {
  const pathname = usePathname();
  return pathname === '/ru' || pathname.startsWith('/ru/') ? 'ru' : 'en';
};